import { h } from "@stencil/core";
const render = () => (h("iframe", { src: "/showcase/pages/shortcuts.html", frameborder: "0" }));
export const shortcutsShowcaseStory = {
    render: render
};
